export default {
  setBrokersSummaryPagination(state, value) {
    state.brokersSummaryPagination = value;
  }
}